import React from 'react';
import Layout from './Layout';

function UserSettings() {
    return (
        <Layout>
            <div className="container mt-4">
                <h2>User Settings</h2>
                <div className="card p-4">
                    <p>User profile management would go here.</p>
                    <div className="mb-3">
                        <label className="form-label">Username</label>
                        <input type="text" className="form-control" value="admin" disabled />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input type="email" className="form-control" value="admin@example.com" disabled />
                    </div>
                    <button className="btn btn-secondary" disabled>Change Password</button>
                </div>
            </div>
        </Layout>
    );
}

export default UserSettings;
